import { encrypt } from '../helpers/Helpers';

export default async function EnviarEmail({crewCode, email, timestamp}) {
    // Encriptar el email antes de enviar
    const encryptedEmail = encrypt(email, process.env.REACT_APP_KEY);

    const url = "https://gops.azulhandling.com/LoginPage/procesos_seguros/EnviarEmail.php";
    const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            crewCode,
            email: encryptedEmail,
            timestamp
        }),
    })
    
    if(res.status == 200){
        return await res.text()
    }else{
        return "Error obteniendo los datos"
    }
}